// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layer-list-panel[data-v-33d54691]{height:100%}.container-infos-layers[data-v-33d54691]{height:calc(100% - 91px);border-bottom:1px solid #c3c0c0;border-radius:0;overflow-y:auto}.layer_strip[data-v-33d54691]:nth-child(2n){background-color:rgba(24,124,198,.1)}.flip-list-move[data-v-33d54691]{transition:transform .6s}", ""]);
// Exports
module.exports = exports;
